// Separate file for constants used in offers for easier mocking

export const OFFER_PREVIEW_DEBOUNCE_TIME: number = 1000
export const OFFER_FORM_DEBOUNCE_TIME: number = 400
